import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import Text from '../../components/Text';
import { updateLeadApplication } from '../../services/truststartService';

import styles from './Leads.styles.module.scss';

const statusActionName = 'status';
const delayBeforePollingInMs = 3 * 1000;
const expireInMs = 3 * 60 * 1000;

const delay = (delayInMs) => new Promise((resolve) => { setTimeout(() => resolve(), delayInMs); });

const renderResponse = (response) => {
  if (response.timeout) {
    return (
      <>
        <Text value="We were not able to receive a response from the lender." />
        <br />
        <Text value="You can retry your loan application at a later time." />
      </>
    );
  }
  if (response.status === 202) {
    return (
      <>
        <Text value="Congratulations! Your application has been accepted." />
        <br />
        <Text value="To sign your agreement click this link: " />
        <a href={response.redirectUrl}>{ response.redirectLabel }</a>
      </>
    );
  }
  if (response.status === 409) {
    if (!response.returnUrl) {
      return (
        <Text value="Sorry, we are unable to process your application at this time." />
      );
    }
    window.location.href = response.returnUrl;
    return null;
  }
  return (
    <Text value="Please stay on this page while your application is being processed (it might take a couple minutes).
                  This page will automatically update with more details."
    />
  );
};

export default function LeadsComplete(props) {
  const { requestKey, formData } = props;
  const [status, setStatus] = useState({ polling: true });

  useEffect(() => {
    const pollForApplicationStatus = async (expireAt) => {
      if (expireAt < Date.now()) {
        setStatus({ timeout: true, polling: false });
        return false;
      }
      await delay(delayBeforePollingInMs);
      const response = await updateLeadApplication(requestKey, formData, statusActionName);
      if (!response.authenticated) return false;
      if (response.status === 404) {
        return pollForApplicationStatus(expireAt);
      }
      setStatus(response);
      return false;
    };
    pollForApplicationStatus(Date.now() + expireInMs);
  }, [requestKey, formData]);

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <h3>
          <Text value="Thank You" />
        </h3>
      </div>
      <div className="form-group-wrapper">
        <Container>
          { renderResponse(status) }
        </Container>
      </div>
    </div>
  );
}
